import { BarGraphData, LineGraphData } from 'pages/Analytics/types';

type RankedExportPoint = {
  journey_id?: string;
  name?: string;
  value?: number;
  y?: number;
};

/** Turn line-chart points into CSV rows. Column titles come from the chart axis labels. */
export function buildLineGraphExportRows(
  lineData: LineGraphData,
  xAxisLabel = 'Time',
  yAxisLabel = 'Value',
): Record<string, string>[] {
  return lineData.map((dataPoint) => ({
    Name: dataPoint.name ?? '',
    [xAxisLabel]: String(dataPoint.x ?? ''),
    [yAxisLabel]: String(dataPoint.y ?? ''),
  }));
}

/**
 * Turn bar-chart points into CSV rows.
 * Over-time bars use the same columns as line charts; ranked bars use Journey ID / Name / Value.
 */
export function buildBarGraphExportRows(
  barData: BarGraphData,
  forceOverTime: boolean,
  xAxisLabel = 'Time',
  yAxisLabel = 'Value',
): Record<string, string>[] {
  if (forceOverTime) {
    return buildLineGraphExportRows(barData, xAxisLabel, yAxisLabel);
  }

  return barData.map((dataPoint) => ({
    'Journey ID': dataPoint.journey_id ?? '',
    Name: dataPoint.name ?? '',
    Value: String(dataPoint.value ?? dataPoint.y ?? ''),
  }));
}

/** Turn table rows into CSV rows. Uses `value`, or `y` if `value` is missing. */
export function buildTableGraphExportRows(tableData: RankedExportPoint[]): Record<string, string>[] {
  return tableData.map((dataPoint) => ({
    'Journey ID': dataPoint.journey_id ?? '',
    Name: dataPoint.name ?? '',
    Value: String(dataPoint.value ?? dataPoint.y ?? ''),
  }));
}
